// extracted by mini-css-extract-plugin
export default {"title":"NewFacilities_title__uUwUq","boxForm":"NewFacilities_boxForm__oxD9e","form":"NewFacilities_form__3ksBd"};